import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {StatisticsComponent} from "./components/statistics/statistics.component";
import {prlAuthentificationGuard} from "../../shared/services/prl-authentification-guard";

const routes: Routes = [
    {
        path: 'statistic',
        component: StatisticsComponent,
        canActivate: [prlAuthentificationGuard],
        data: {pageName: 'Affiliate Statistics'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlStatisticsRoutingModule {
}
